<template>
  <div class="page contact">
    <!-- <navigation>联系客服</navigation> -->
    <div class="contact-detail">
      <img src="./images/img_kefu@2x.png">
    </div>
    <nd-button class="btn" @click="serviceVisible=true" style="background: linear-gradient( 270deg, #FF9551 0%, #FB571C 100%);">联系客服</nd-button>

    <!-- 联系客服弹窗框 -->
    <nd-dialog v-model="serviceVisible" @confirm="callService" @close='serviceVisible=false' confirmText="拨打客服电话" :easyToClose="true" :closeBtn="true">
      <div class="service-dialog">
        <div class="title">联系客服</div>
        <div class="description">拨打客服电话进行咨询</div>
        <div class="telphone">服务时间：</div>
        <div class="telphone">周一到周五 上午9:00-12:00 下午13:30-18:00</div>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
import { mockHrefJump } from '@/assets/utils'

export default {
  data () {
    return {
      serviceVisible: false
    }
  },
  mounted () {
    this.$bus.$emit('ready')
  },
  methods: {
    callService () {
      mockHrefJump(`tel:4000100008`)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

 /deep/.nd-dialog {
  .dialog-footer {
    justify-content: center !important;
  }
  .confirm-btn {
    width: 420px !important;
    background: linear-gradient( 270deg, #FF9551 0%, #FB571C 100%);
  }
  .line {
    display: none;
  }
}
.contact {
  background: #F7F7F7;
  .btn {
    position: absolute;
    left: 50%;
    left:50%;
    transform: translate(-50%,-50%);
    bottom: 40px;
  }
  .contact-detail {
    padding: 40px 30px;
    img {
      width: 100%;
    }
  }
 
  .service-dialog {
    padding-top: 10px;
    padding: 0 48px;
    padding-bottom: 50px;
    font-family: PingFangSC-Regular,PingFang SC;
  
    .title {
      font-size: 42px;
      height: 72px;
      line-height: 72px;
      font-family: PingFangSC-Semibold,PingFang SC;
      font-weight: 600;
    }

    .description {
      font-size: 30px;
      height: 32px;
      line-height: 32px;
      margin-top: 22px;
      font-weight: 400;
    }
    .description1{
      font-size: 30px;
      height: 32px;
      line-height: 32px;
      margin: 12px auto 12px;
      font-weight: 400;
    }

    .telphone {
      font-size: 24px;
      height: 40px;
      line-height: 40px;
      margin-top: 2px;
      font-weight: 400;
      color: @fc3;
    }
  }
}</style>